// 全部本地资源 —— 不引用 readdy.ai / 任何外部图床。
// 有品牌素材的用素材(assets/brand/terminals),没有的用诚实占位,不编外部图。
const PLACEHOLDER = '/brand/placeholder.svg';

/** 首屏 hero:真·无缝循环动画(assets/web-hero/hero-final.webp),不是三帧假动画 */
export const fleetHero = {
  animated: '/brand/fleet-hero.webp',
  poster: '/brand/fleet-hero-poster.png',
};
/** 兼容旧调用点:原本是三帧轮播,现在同一张动图即可 */
export const fleetHeroFrames = [fleetHero.animated];

/**
 * 产品卡用**抠像版**(assets/brand/cutouts,透明底)而不是原始渲染图。
 * 理由不是好看:原图自带一块比卡片更亮的黑底,放进卡片就是一块看得见的矩形 ——
 * 加混合模式和遮罩都只是掩盖,透明底才是根治。
 *
 * `interfaceImage` 是唯一一张不是抠像的:AI 眼镜没有自家渲染素材。原型用的是
 * readdy.ai 的**在线**生成图,随外部资源一起被剥掉了(那条规矩针对的是**运行时**
 * 外链:私有网里取不到、国内也不稳)。现在把它**取回来落地成本地文件** ——
 * 原图存 `assets/brand/terminals/07-ar-glasses.jpg`,页面用压过的 webp。
 * 一次性下载 ≠ 运行时依赖,规矩没破。
 */
export const productImages = {
  cogImage: '/brand/cut-human.png',
  interfaceImage: '/brand/t-glasses.webp', // 见上:一次性落地的 AR 眼镜图
  actuationImage: '/brand/cut-dog.png',
  robotImage: '/brand/cut-robot.png',
  droneImage: '/brand/cut-drone.png',
  ugvImage: '/brand/cut-rover.png',
};
export const terminalImages = {
  human: '/brand/t-human.png',
  robot: '/brand/t-robot.png',
  dog: '/brand/t-dog.png',
  dogCompanion: '/brand/t-dog-companion.png',
  hexapod: '/brand/t-hexapod.png',
  drone: '/brand/t-drone.png',
  rover: '/brand/t-rover.png',
};
// 以下暂无自有素材 —— 用占位而非外部图床
export const scenarioImages = {
  scenarioWarehouse: PLACEHOLDER, scenarioSecurity: PLACEHOLDER, scenarioConstruction: PLACEHOLDER,
};
export const blogImages = [PLACEHOLDER, PLACEHOLDER, PLACEHOLDER];
export const teamImages = [PLACEHOLDER, PLACEHOLDER, PLACEHOLDER, PLACEHOLDER];
